import { render, staticRenderFns } from "./changlang.vue?vue&type=template&id=476ae66e&scoped=true&"
import script from "./changlang.vue?vue&type=script&lang=js&"
export * from "./changlang.vue?vue&type=script&lang=js&"
import style0 from "./changlang.vue?vue&type=style&index=0&id=476ae66e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476ae66e",
  null
  
)

export default component.exports